/**
 * Resort Live Maps Service
 * API client for resort live status data
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

export const fetchLiveResorts = async () => {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');

  const response = await fetch(buildApiUrl('/resort-live-maps'), {
    headers: getAuthHeaders(idToken),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(err.message || err.error || 'Failed to fetch live resorts');
  }
  const data = await response.json();
  return data.resorts;
};

export const fetchResortMapData = async (skiAreaId) => {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');

  const response = await fetch(buildApiUrl(`/resort-live-maps/${skiAreaId}/map`), {
    headers: getAuthHeaders(idToken),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(err.message || err.error || 'Failed to fetch resort map data');
  }
  return response.json();
};
